import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CurrencyPipe, DecimalPipe, DatePipe } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { CombeniaSyncService } from "./services/CombeniaService/CombeniaSyncService";
import { CombeniaService } from "./services/CombeniaService/CombeniaService";
import { BackendDataService } from "./services/backendDataService/backendDataService";
import { TableModel } from './models/table.model';
import { ModalComponent } from './components/modal/modal.component';
import { UserModel } from "./models/UserModel";
import { ReportModel } from "./models/ReportModel";
import { FilterModel } from "./models/FilterModel";
import { OrderModel } from "./models/OrderModel";
import { OrderModule } from 'ngx-order-pipe';

import { AuthGuardService } from './services/guards/auth-guard.service';

import { BrandModel } from './models/BrandModel';
import { ModelsModel } from './models/ModelsModel';
import { ClientModel } from './models/ClientModel';
import { DeactivationGuard } from './services/guards/deactivation.guard';
import { AlertComponent } from './components/alert/alert.component';
import { ProposalModel } from './models/ProposalModel';

import { MediaModel } from './models/MediaModels';
import { SelectionModel } from './models/SelectionModel';
import { ImageModalComponent } from './components/image-modal/image-modal.component';
import { DragulaModule } from 'ng2-dragula';
import { ConfiguratorModel } from './components/configurator/ConfiguratorModel';
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
    declarations: [AppComponent, ModalComponent,AlertComponent, ImageModalComponent],
    entryComponents: [ModalComponent,AlertComponent, ImageModalComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        FormsModule,
        OrderModule,
        DragulaModule.forRoot()
    ],
    providers: [
        StatusBar,
        SplashScreen,
        CombeniaService,
        CombeniaSyncService,
        UserModel,
        FilterModel,
        ConfiguratorModel,
        OrderModel,
        CurrencyPipe,
        DecimalPipe,
        BackendDataService ,
        DatePipe,
        ReportModel,
        BrandModel,
        ModelsModel,
        ClientModel,
        ProposalModel,
        SelectionModel,
        MediaModel,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        TableModel,
        AuthGuardService,
        DeactivationGuard,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
